import React, { Fragment } from 'react'
import './NewChatBottom.css'
import { Dropdown } from 'react-bootstrap';
import { useTranslation } from "react-i18next";
import { FiX, FiMessageCircle } from 'react-icons/fi';
import { BsWhatsapp } from 'react-icons/bs';
import { BiMessageRounded } from 'react-icons/bi';
import { FaFacebook, FaInstagram, FaHome, FaEnvelope } from 'react-icons/fa';

const NewChatBottom = (props) => {
    const [t] = useTranslation('common')
    const appAccess = props.appAccess
    let channelPageListItems = []
    if (props.facebook_pageAccess && props.selectedChannel === 'facebook') {
        channelPageListItems = props.facebook_pageAccess.map(pageAccessItem => (
            <Dropdown.Item eventKey={pageAccessItem.pageId} className='newChatdropDownItem' onClick={() => props.onNewConvChannelIdSelected(pageAccessItem)}>{pageAccessItem.pageName} <i className="fab fa-facebook facebookIconColor" /></Dropdown.Item>
        ))
    }
    else if (props.facebook_pageAccess && props.selectedChannel === 'ig_media') {
        channelPageListItems = props.facebook_pageAccess.filter(pageAccessItem => pageAccessItem.instagramId).map(pageAccessItem => (
            <Dropdown.Item eventKey={pageAccessItem.pageId} className='newChatdropDownItem' onClick={() => props.onNewConvChannelIdSelected(pageAccessItem)}>{pageAccessItem.pageName} <i className="fab fa-instagram instagramIconColor" /></Dropdown.Item>
        ))
    }
    const selectChannelNameSection = (
        <div className="selectChannelPage">
            <Dropdown drop='up' className="selectChannelUp">
                <Dropdown.Toggle variant='outline-success' className='SelectPageDropDownBtn'>{props.NewSelectedChannelObj.pageName}</Dropdown.Toggle>
                <Dropdown.Menu className="newChatCustomMenu">
                    <h6 className='mainTitleChannelSelect'>{t('Select page')}</h6>
                    <Fragment>
                        {channelPageListItems}
                    </Fragment>
                </Dropdown.Menu>
            </Dropdown>
        </div>
    )

    return (
        <div className='row chatBottom'>
            <div className='col-12 costContactsCol '>
                <div className='row chatMenu'>
                    <div className='col-8 cosSelectChatCol8'>
                        <div className="selectChannel">
                            <Dropdown drop='left' className="selectChannelUp">
                                <Dropdown.Toggle variant='outline-success' className='newChatCustomBtn'>{props.selectedChannelElement}</Dropdown.Toggle>
                                <Dropdown.Menu className="newChatCustomMenu">
                                    <h6 className='mainTitleChannelSelect'>{t('Channel list')}</h6>
                                    {
                                        appAccess !== 'DIALER' && <>
                                            <Dropdown.Item eventKey="1" className='newChatdropDownItem' onClick={() => props.OnNewConvChannelSelected('whatsapp')}>{t('whatsapp')} <i className="fab fa-whatsapp whatsappIconColorInNewChatDropDown" /></Dropdown.Item>
                                            <Dropdown.Item eventKey="2" className='newChatdropDownItem' onClick={() => props.OnNewConvChannelSelected('facebook')}>{t('facebook')} <i className="fab fa-facebook facebookIconColor" /></Dropdown.Item>
                                            {/* <Dropdown.Item eventKey="1" className='newChatdropDownItem' onClick={() => props.OnNewConvChannelSelected('messenger')}>{t('messenger')} <i className="fab fa-facebook-messenger messengerIconColor" /></Dropdown.Item> */}
                                            {/* <Dropdown.Item eventKey="1" className='newChatdropDownItem' onClick={() => props.OnNewConvChannelSelected('instagram')}>{t('instagram')} <i className="fab fa-instagram instagramIconColor" /></Dropdown.Item> */}
                                            {/* <Dropdown.Item eventKey="3" className='newChatdropDownItem' onClick={() => props.OnNewConvChannelSelected('ig_media')}>{t('ig_media')} <i className="fab fa-instagram instagramIconColor" /></Dropdown.Item> */}
                                            <Dropdown.Item eventKey="4" className='newChatdropDownItem' onClick={() => props.OnNewConvChannelSelected('sms')}>{t('sms')} <i className="fas fa-sms smsIconColor" /></Dropdown.Item>
                                            <Dropdown.Item eventKey="5" className='newChatdropDownItem' onClick={() => props.OnNewConvChannelSelected('mail')}>{t('mail')} <i className="fas fa-envelope mailIconColor" /></Dropdown.Item>
                                        </>
                                    }
                                    <Dropdown.Item eventKey="6" className='newChatdropDownItem' onClick={() => props.OnNewConvChannelSelected('company')}>{t('company')} <i className="fas fa-home companyChat" /></Dropdown.Item>

                                </Dropdown.Menu>
                            </Dropdown>
                            <input className='ChannelInput' onKeyDown={(e) => props.onKeyBoardClick(e, 'newChatBtnClicked')} onChange={props.newCharOnConvName} value={props.NewConvNameTextBoxValue} type='text' placeholder={t('Enter ID')}></input>
                        </div>
                        {(props.selectedChannel === 'facebook' || props.selectedChannel === 'ig_media') && selectChannelNameSection}

                    </div>
                    <div className='col-4 costCallCol'>
                        <FiX onClick={props.onExitNewChatClicked} className="costExit" />
                        <FiMessageCircle className='chatIcon chatIconGreen' onClick={props.OnNewConvClicked} />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default NewChatBottom